export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/app/src/pages/index.vue'),
    /* no children */
    meta: {
      "requiresAuth": false
    }
  },
  {
    path: '/:404(.*)',
    name: '/[...404]',
    component: () => import('/app/src/pages/[...404].vue'),
    /* no children */
    meta: {
      "requiresAuth": false
    }
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('/app/src/pages/account.vue'),
    /* no children */
    meta: {
      "layout": "AppLayout",
      "requiresAuth": true
    }
  },
  {
    path: '/aftersale',
    name: '/aftersale',
    component: () => import('/app/src/pages/aftersale.vue'),
    /* no children */
    meta: {
      "requiresAuth": true
    }
  },
  {
    path: '/confirmregistration',
    name: '/confirmregistration',
    component: () => import('/app/src/pages/confirmregistration.vue'),
    /* no children */
    meta: {
      "requiresAuth": false
    }
  },
  {
    path: '/dashboard',
    name: '/dashboard',
    component: () => import('/app/src/pages/dashboard.vue'),
    /* no children */
    meta: {
      "requiresAuth": true
    }
  },
  {
    path: '/documents',
    name: 'documentsIndex',
    component: () => import('/app/src/pages/documents.vue'),
    /* no children */
    meta: {
      "layout": "AppLayout",
      "requiresAuth": true
    }
  },
  {
    path: '/installations',
    /* internal name: '/installations' */
    /* no component */
    children: [
      {
        path: '',
        name: 'installations',
        component: () => import('/app/src/pages/installations/index.vue'),
        /* no children */
        meta: {
          "layout": "AppLayout",
          "requiresAuth": true
        }
      },
      {
        path: ':installation_id',
        name: 'installation',
        component: () => import('/app/src/pages/installations/[installation_id].vue'),
        /* no children */
        meta: {
          "requiresAuth": true
        }
      },
      {
        path: 'deliverydetail',
        /* internal name: '/installations/deliverydetail' */
        /* no component */
        children: [
          {
            path: ':id',
            name: 'deliveryDetail',
            component: () => import('/app/src/pages/installations/deliverydetail/[id].vue'),
            /* no children */
            meta: {
              "requiresAuth": true
            }
          },
          {
            path: 'order',
            /* internal name: '/installations/deliverydetail/order' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'deliveryDetailPlanning',
                component: () => import('/app/src/pages/installations/deliverydetail/order/[id].vue'),
                /* no children */
                meta: {
                  "requiresAuth": true
                }
              }
            ],
          }
        ],
      },
      {
        path: 'documents',
        /* internal name: '/installations/documents' */
        /* no component */
        children: [
          {
            path: ':installation_id',
            name: 'documents',
            component: () => import('/app/src/pages/installations/documents/[installation_id].vue'),
            /* no children */
            meta: {
              "layout": "AppLayout",
              "requiresAuth": true
            }
          }
        ],
      },
      {
        path: 'ichoosr',
        /* internal name: '/installations/ichoosr' */
        /* no component */
        children: [
          {
            path: ':id',
            name: 'ichoosr',
            component: () => import('/app/src/pages/installations/ichoosr/[id].vue'),
            /* no children */
            meta: {
              "requiresAuth": true
            }
          }
        ],
      },
      {
        path: 'inspectiondetail',
        /* internal name: '/installations/inspectiondetail' */
        /* no component */
        children: [
          {
            path: ':id()_:source',
            name: 'inspectionDetail',
            component: () => import('/app/src/pages/installations/inspectiondetail/[id]_[source].vue'),
            /* no children */
            meta: {
              "requiresAuth": true
            }
          }
        ],
      },
      {
        path: 'invoicedetail',
        /* internal name: '/installations/invoicedetail' */
        /* no component */
        children: [
          {
            path: ':id',
            name: 'invoiceDetail',
            component: () => import('/app/src/pages/installations/invoicedetail/[id].vue'),
            /* no children */
            meta: {
              "requiresAuth": true
            }
          },
          {
            path: 'list',
            /* internal name: '/installations/invoicedetail/list' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'invoiceDetailList',
                component: () => import('/app/src/pages/installations/invoicedetail/list/[id].vue'),
                /* no children */
                meta: {
                  "requiresAuth": true
                }
              }
            ],
          }
        ],
      },
      {
        path: 'netoperator',
        /* internal name: '/installations/netoperator' */
        /* no component */
        children: [
          {
            path: ':installation_id',
            name: 'netoperator',
            component: () => import('/app/src/pages/installations/netoperator/[installation_id].vue'),
            /* no children */
            meta: {
              "layout": "AppLayout",
              "requiresAuth": true
            }
          }
        ],
      },
      {
        path: 'offerdetail',
        /* internal name: '/installations/offerdetail' */
        /* no component */
        children: [
          {
            path: ':id()_:version',
            name: 'offerDetail',
            component: () => import('/app/src/pages/installations/offerdetail/[id]_[version].vue'),
            /* no children */
            meta: {
              "layout": "AppLayout",
              "requiresAuth": true
            }
          },
          {
            path: 'list',
            /* internal name: '/installations/offerdetail/list' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'offerDetailList',
                component: () => import('/app/src/pages/installations/offerdetail/list/[id].vue'),
                /* no children */
                meta: {
                  "requiresAuth": true
                }
              }
            ],
          },
          {
            path: 'upsell',
            /* internal name: '/installations/offerdetail/upsell' */
            /* no component */
            children: [
              {
                path: ':id()_:version',
                name: 'offerUpsell',
                component: () => import('/app/src/pages/installations/offerdetail/upsell/[id]_[version].vue'),
                /* no children */
                meta: {
                  "requiresAuth": true
                }
              }
            ],
          }
        ],
      },
      {
        path: 'orderdetail',
        /* internal name: '/installations/orderdetail' */
        /* no component */
        children: [
          {
            path: ':id',
            name: 'orderDetail',
            component: () => import('/app/src/pages/installations/orderdetail/[id].vue'),
            /* no children */
            meta: {
              "requiresAuth": true
            }
          }
        ],
      },
      {
        path: 'repairs',
        /* internal name: '/installations/repairs' */
        /* no component */
        children: [
          {
            path: ':repair_id',
            name: 'repair',
            component: () => import('/app/src/pages/installations/repairs/[repair_id].vue'),
            /* no children */
            meta: {
              "requiresAuth": true,
              "feature": "support"
            }
          },
          {
            path: 'list',
            /* internal name: '/installations/repairs/list' */
            /* no component */
            children: [
              {
                path: ':installation_id',
                name: 'repairsList',
                component: () => import('/app/src/pages/installations/repairs/list/[installation_id].vue'),
                /* no children */
                meta: {
                  "requiresAuth": true,
                  "feature": "support"
                }
              }
            ],
          }
        ],
      },
      {
        path: 'survey',
        /* internal name: '/installations/survey' */
        /* no component */
        children: [
          {
            path: ':order_id',
            name: 'installations_survey',
            component: () => import('/app/src/pages/installations/survey/[order_id].vue'),
            /* no children */
            meta: {
              "requiresAuth": true,
              "feature": "survey"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/app/src/pages/login.vue'),
    /* no children */
    meta: {
      "layout": "BlankLayout",
      "requiresAuth": false
    }
  },
  {
    path: '/loyalty',
    /* internal name: '/loyalty' */
    /* no component */
    children: [
      {
        path: '',
        name: 'loyalty',
        component: () => import('/app/src/pages/loyalty/index.vue'),
        /* no children */
        meta: {
          "requiresAuth": true,
          "feature": "loyalty",
          "layout": "AppLayout"
        }
      }
    ],
  },
  {
    path: '/monitoring',
    /* internal name: '/monitoring' */
    /* no component */
    children: [
      {
        path: 'device-details',
        name: 'deviceDetails',
        component: () => import('/app/src/pages/monitoring/device-details.vue'),
        /* no children */
        meta: {
          "layout": "AppLayout",
          "requiresAuth": true,
          "feature": "monitoring"
        }
      },
      {
        path: 'ev',
        name: 'ev',
        component: () => import('/app/src/pages/monitoring/ev.vue'),
        /* no children */
        meta: {
          "layout": "AppLayout",
          "requiresAuth": true,
          "feature": "monitoring.ev"
        }
      },
      {
        path: 'feed',
        name: 'monitoring',
        component: () => import('/app/src/pages/monitoring/feed.vue'),
        /* no children */
        meta: {
          "layout": "AppLayout",
          "requiresAuth": true,
          "feature": "monitoring"
        }
      },
      {
        path: 'history',
        name: 'history',
        component: () => import('/app/src/pages/monitoring/history.vue'),
        /* no children */
        meta: {
          "layout": "AppLayout",
          "requiresAuth": true,
          "feature": "monitoring"
        }
      },
      {
        path: 'insights',
        name: 'insights',
        component: () => import('/app/src/pages/monitoring/insights.vue'),
        /* no children */
        meta: {
          "layout": "AppLayout",
          "requiresAuth": true,
          "feature": "monitoring"
        }
      }
    ],
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('/app/src/pages/notifications.vue'),
    /* no children */
    meta: {
      "requiresAuth": true
    }
  },
  {
    path: '/reviews',
    name: 'reviews',
    component: () => import('/app/src/pages/reviews.vue'),
    /* no children */
    meta: {
      "requiresAuth": true,
      "layout": "AppLayout",
      "feature": "reviews"
    }
  },
  {
    path: '/support',
    /* internal name: '/support' */
    /* no component */
    children: [
      {
        path: '',
        name: 'support',
        component: () => import('/app/src/pages/support/index.vue'),
        /* no children */
        meta: {
          "requiresAuth": true,
          "feature": "support"
        }
      },
      {
        path: ':issue_id',
        name: 'issueDetail',
        component: () => import('/app/src/pages/support/[issue_id].vue'),
        /* no children */
        meta: {
          "requiresAuth": true,
          "feature": "support"
        }
      },
      {
        path: 'createissue',
        name: 'issueCreate',
        component: () => import('/app/src/pages/support/createissue.vue'),
        /* no children */
        meta: {
          "requiresAuth": true,
          "feature": "support"
        }
      }
    ],
  }
]
